module.exports = __webpack_public_path__ + "img/res_img.aa15b351.jpg";